import { render, staticRenderFns } from "./CreateEmployeeButton.vue?vue&type=template&id=0549d7d3&"
import script from "./CreateEmployeeButton.vue?vue&type=script&lang=js&"
export * from "./CreateEmployeeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports